import {
   FETCH_FORMS
} from '../actions/form';


export const initialState = {
    isFetching: true,
    data: null
};



export const extendForms = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_FORMS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_FORMS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/qaForm.js